export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ff5451759805815a6d935cc0c34e30b009c4d8e56&name=fetchTypeahead!'